module.exports = __webpack_public_path__ + "img/1541750401.ca397f19.jpg";